import { COOKIE_I18N_LANG } from '@bridebook/web/app-shared/lib/i18n/cookies';
import { setCookie } from '@bridebook/web/app-shared/lib/utils/set-cookie';

export const setLanguageCookie = (locale: string) => {
  setCookie(COOKIE_I18N_LANG, locale, 365, 'days');
};
